import { useQuery } from "@tanstack/react-query";
import { dashboardSettingsApi } from "../api";
import { qk } from "../../lib/queryKeys";
import { useSessionQuery } from "../../features/auth/hooks";

export const useCurrentClientDashboardSettings = () => {
  const { data: session } = useSessionQuery();
  const clientId = session?.user?.client_id ?? null;

  return useQuery({
    queryKey: qk.dashboardSettings(clientId),
    queryFn: () => dashboardSettingsApi.listCurrentClientDashboardSettings(),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
};
